import React from "react";
import { Link } from "react-router-dom";
import {
  Package,
  CheckCircle2,
  Clock,
  ArrowRight,
  ChevronRight,
  Sparkles,
  Truck,
} from "lucide-react";

import serumImg from "../assests/faceimg.webp"; // Path check kar lein

interface OrderItem {
  id: string;
  orderNumber: string;
  date: string;
  status: "Delivered" | "In Transit" | "Processing";
  total: number;
  items: {
    name: string;
    price: number;
    quantity: number;
    image: string;
  }[];
}

const mockOrders: OrderItem[] = [
  {
    id: "ord-1",
    orderNumber: "CEL-99201",
    date: "02 Aug 2026",
    status: "Delivered",
    total: 100.0,
    items: [
      {
        name: "Glow Niacinamide Serum",
        price: 48.0,
        quantity: 1,
        image: serumImg,
      },
      {
        name: "Ceramide Hydrating Barrier Cream",
        price: 52.0,
        quantity: 1,
        image: serumImg,
      },
    ],
  },
  {
    id: "ord-2",
    orderNumber: "CEL-88102",
    date: "15 Jul 2026",
    status: "Delivered",
    total: 36.0,
    items: [
      {
        name: "Radiant Rice Essence Toner",
        price: 36.0,
        quantity: 1,
        image: serumImg,
      },
    ],
  },
];

const Orders: React.FC = () => {
  return (
    <div className="min-h-[calc(100vh-80px)] bg-[#FAF8F5] py-12 px-4 sm:px-6 lg:px-8 flex justify-center">
      <div className="w-full max-w-5xl space-y-8">
        
        {/* Breadcrumb */}
        <div className="flex items-center gap-2 text-xs text-gray-400 font-medium">
          <Link to="/" className="hover:text-black">Home</Link>
          <ChevronRight size={12} />
          <Link to="/profile" className="hover:text-black">Profile</Link>
          <ChevronRight size={12} />
          <span className="text-[#9D7D4F]">Order History</span>
        </div>

        {/* Title */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-b border-[#E8E2D9] pb-6">
          <div>
            <div className="flex items-center gap-2 text-[#9D7D4F] text-xs font-semibold uppercase tracking-[2px] mb-1">
              <Sparkles size={13} /> Purchase Log
            </div>
            <h1 className="font-serif text-3xl font-semibold text-[#1F1B18]">
              My Orders
            </h1>
          </div>
          <p className="text-xs text-gray-500 font-medium">
            {mockOrders.length} Completed Orders
          </p>
        </div>

        {/* Order Cards List */}
        <div className="space-y-6">
          {mockOrders.map((order) => (
            <div
              key={order.id}
              className="bg-white rounded-3xl border border-[#E8E2D9] shadow-sm overflow-hidden"
            >
              {/* Order Header */}
              <div className="p-6 bg-[#FAF8F5] border-b border-[#E8E2D9] flex flex-wrap items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                  <div className="p-2.5 bg-white rounded-xl text-[#9D7D4F] border border-[#E8E2D9]">
                    <Package size={20} />
                  </div>
                  <div>
                    <span className="text-[10px] uppercase tracking-wider text-gray-400 block font-semibold">
                      Order ID
                    </span>
                    <h3 className="font-serif font-bold text-base text-[#1F1B18]">
                      #{order.orderNumber}
                    </h3>
                  </div>
                </div>

                <div className="flex items-center gap-6 text-xs">
                  <div>
                    <span className="text-[10px] uppercase tracking-wider text-gray-400 block">Date</span>
                    <span className="font-medium text-[#1F1B18]">{order.date}</span>
                  </div>
                  <div>
                    <span className="text-[10px] uppercase tracking-wider text-gray-400 block">Total</span>
                    <span className="font-semibold text-[#1F1B18]">${order.total.toFixed(2)}</span>
                  </div>
                  <span className="inline-flex items-center gap-1 bg-emerald-50 text-emerald-600 border border-emerald-200 text-[10px] font-semibold px-2.5 py-1 rounded-full uppercase tracking-wider">
                    <CheckCircle2 size={11} /> {order.status}
                  </span>
                </div>
              </div>

              {/* Order Items */}
              <div className="p-6 divide-y divide-[#E8E2D9]/60">
                {order.items.map((item, index) => (
                  <div key={index} className="py-3 first:pt-0 last:pb-0 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-4">
                      <img
                        src={item.image}
                        alt={item.name}
                        className="w-14 h-14 object-cover rounded-xl bg-[#F7F4EF] border border-[#E8E2D9]"
                      />
                      <div>
                        <h4 className="font-serif font-semibold text-sm text-[#1F1B18]">{item.name}</h4>
                        <p className="text-xs text-gray-500 mt-0.5">Qty: {item.quantity} • ${item.price.toFixed(2)}</p>
                      </div>
                    </div>
                    <Link
                      to="/shop"
                      className="text-xs text-[#9D7D4F] hover:underline font-semibold flex items-center gap-1"
                    >
                      Buy Again <ArrowRight size={12} />
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default Orders;